import { QueryManagerType, dcSecurityRights } from '@nibras/core/common';
import { dcDataStoreItem } from './datastore-item.model';
import { dcQuery } from './dcquery.model';

export class dcDataReference<T extends dcQuery = dcQuery> implements dcDataStoreItem {
  Key: string;
  ID: number;
  AttributeTemplateVersionID: number;
  AttributeID: number;
  QueryManagerID: number;
  QueryManagerTypeID: QueryManagerType;
  QueryManagerName: string;
  Queries: Array<T>;
  Security: dcSecurityRights;

  constructor() {
    this.Queries = [];
  }
}
